import React from "react";
import "./PillarCard.css";

const PillarCard = ({ background, heading }) => {
  return (
    <div>
      <div className="pillar-card d-flex flex-column align-items-center justify-content-start">
        <div className="pillar-image">
          <img src={background} alt="" loading="lazy" />
        </div>
        <div className="pillar-heading">{heading}</div>
      </div>
    </div>
  );
};

export default PillarCard;
